import React from "react";
import moment from "moment";
import PropTypes from "prop-types";

const ChevronRight = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    className='websdk-h-6 websdk-w-6 websdk-mr-3 websdk-text-td-primary'
    fill='none'
    viewBox='0 0 24 24'
    stroke='currentColor'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M9 5l7 7-7 7'
    />
  </svg>
);

const CaseTableAppoitments = ({ cases, appData, onView }) => {
  if (cases.length === 0) {
    return <span> </span>;
  }

  const getFirstLetterToUppercase = st => {
    return st[0].toUpperCase() + st.slice(1);
  };

  const getMonthName = month => {
    const { settings } = appData;
    const months = [
      settings.translations.jan_month,
      settings.translations.feb_month,
      settings.translations.mar_month,
      settings.translations.apr_month,
      settings.translations.may_month,
      settings.translations.jun_month,
      settings.translations.jul_month,
      settings.translations.aug_month,
      settings.translations.sept_month,
      settings.translations.oct_month,
      settings.translations.nov_month,
      settings.translations.dec_month
    ];
    return months[month];
  };

  const getStatus = st => {
    const statusLowercase = st.toLowerCase();

    switch (statusLowercase) {
      case "pending":
      case "upcoming":
        return (
          <div className='case-list-status-web-sdk websdk-bg-blue-default websdk-text-purple-dark'>
            {getFirstLetterToUppercase(statusLowercase)}
          </div>
        );
      case "requested":
        return (
          <div className='case-list-status-web-sdk websdk-bg-yellow-300 websdk-text-black'>
            {getFirstLetterToUppercase(statusLowercase)}
          </div>
        );
      case "cancelled":
        return (
          <div className='case-list-status-web-sdk websdk-bg-red websdk-text-white'>
            {getFirstLetterToUppercase(statusLowercase)}
          </div>
        );
      case "complete":
        return (
          <div className='case-list-status-web-sdk websdk-bg-green-900 websdk-text-white'>
            {getFirstLetterToUppercase(statusLowercase)}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {cases.map(caseItem => {
        const updatedData = caseItem;

        const { id, callReason, date, status, patient } = caseItem;

        const dateValue = moment(date).toDate();
        const month = getMonthName(dateValue.getMonth());
        const year = dateValue.getFullYear();
        const numOfDay = dateValue.getDate();
        const fullDate = `${numOfDay} ${month} ${year}`;

        return (
          <button
            key={id}
            type='button'
            className='case-list-web-sdk'
            onClick={() => onView(updatedData)}
          >
            <div className='case-list-container-web-sdk'>
              <div className='case-list-name-web-sdk'>{`${patient.name} ${patient.surname}`}</div>
              <div className='case-list-symptom-web-sdk'>{callReason}</div>
              <div className='case-list-footer-container-web-sdk'>
                <div className='case-list-date-web-sdk'>{fullDate}</div>
                {status && getStatus(status)}
              </div>
            </div>
            <ChevronRight />
          </button>
        );
      })}
    </>
  );
};

const CaseListItemAppoitments = ({ cases, components, appData, onView }) => [
  {
    type: "raw",
    el: (
      <CaseTableAppoitments
        cases={cases}
        components={components}
        appData={appData}
        onView={onView}
      />
    )
  }
];

CaseTableAppoitments.propTypes = {
  cases: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.object)),
  appData: PropTypes.objectOf(PropTypes.any),
  onView: PropTypes.func
};

export default CaseListItemAppoitments;
